import { buttonClasses, SxProps } from '@mui/material'
import { FONT_WEIGHTS, scaledPx } from '@/styles'
import { iconSlot, railTransitionMs } from '../SidebarLayout.data'

interface CurrencySelectorStyles {
  trigger: SxProps
  triggerRail: SxProps
  triggerRound: SxProps
  flagSlot: SxProps
  flagSlotRail: SxProps
  triggerText: SxProps
  flagIcon: SxProps
}

export const currencySelectorStyles: CurrencySelectorStyles = {
  // The main site's currency button, and what the mobile drawer keeps: outlined,
  // centred, flag then code.
  trigger: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'text.primary900',
    borderWidth: 1,
  },
  // The desktop rail's version: width follows the panel, the padding never
  // changes, and the flag sits in a fixed slot at the left so it holds its place
  // as the panel opens.
  triggerRail: {
    justifyContent: 'flex-start',
    width: '100%',
    // Narrower than MUI's 64px floor, so the collapsed rail can hold it.
    minWidth: 0,
    height: scaledPx(iconSlot),
    px: 0,
    py: 0,
    transition: `border-radius ${railTransitionMs}ms ease, background-color .2s, border-color .2s`,
    // The slot owns the spacing; MUI's own icon margins would push the flag off
    // the line every other row keeps.
    [`.${buttonClasses.startIcon}`]: {
      mr: 0,
      ml: 0,
    },
  },
  // Collapsed, only the corners change — a pill radius rather than 50% so the
  // shape stays sane at every width on the way.
  triggerRound: {
    borderRadius: 999,
  },
  flagSlot: {
    flexShrink: 0,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  // The icon target less the button's two borders, so the flag centres on the same
  // vertical line as every other glyph in the rail.
  flagSlotRail: {
    width: scaledPx(iconSlot - 4),
    height: '100%',
  },
  triggerText: {
    typography: 'textMdSemibold',
    fontWeight: FONT_WEIGHTS.HEAVY,
  },
  flagIcon: {
    width: scaledPx(18),
  },
}
